//import 'src/app/pages/hubs/hubJS/jquery-min.js';
//import  'jquery';
//import "//code.jquery.com/jquery-2.1.4.min.js"
//import 'src/app/pages/hubs/hubJS/jquery-min.js';
import 'src/app/pages/hubs/hubJS/jquery.signalR-2.4.0.js';
import 'src/app/pages/hubs/hubJS/hubs.js';
import { Component, HostAttributeToken, inject } from '@angular/core';
import { HubManager } from 'src/app/pages/hubs/common/HubManager';
//import 'src/app/pages/hubs/hubJS/hubs';
declare let $: any;
let self: any;
export class Hub {
    private _qbr_endpoint: any = null;
    private _qbr_loaded: boolean = false;

    constructor() {
        self = this;
        try {
            self._qbr_endpoint = $.connection[self.constructor.HUB_Name];
            console.log(self.constructor.HUB_Name + ' Hub initiated');
            if (self._qbr_endpoint) {
                //const method = this.getAllMethods(self);

                if (self.constructor.HUB_Name == 'CommunicationHub') {
                    self._qbr_endpoint.client['inboundCall'] = self['inboundCall'];
                    self._qbr_endpoint.client['callEnded'] = self['callEnded'];
                    self._qbr_endpoint.client['receiveMessage'] = self['receiveMessage'];
                    self._qbr_endpoint.client['remoteLogoffNotification'] = self['remoteLogoffNotification'];
                    self._qbr_endpoint.client['receiveLiveTranscript'] = self['receiveLiveTranscript'];
                    self._qbr_endpoint.client['receiveCallAnalytics'] = self['receiveCallAnalytics'];
                    self._qbr_endpoint.client['sendcallfailurealert'] = self['sendcallfailurealert'];
                    self._qbr_endpoint.client['sendSoftphoneDeviceIssue'] = self['sendSoftphoneDeviceIssue'];
                }
                
                if (self.constructor.HUB_Name == 'AgentLiveViewHub') {
                    self._qbr_endpoint.client['liveView'] = self['liveView']; 
                }

                //if (self.constructor.name == 'TMHub')
                //    self._qbr_endpoint.client['join'] = self['recordLocked'];

              //  console.log(self.constructor.name,this.getAllMethods(self));

                for (const prop in self._qbr_endpoint.server) {
                    self[prop] = self.createProxyFunc(prop);
                }
              
                self._qbr_loaded = true;
            }
        } catch (exception) {
            // JSErrorService.instance(true).LogJSError({ message: exception.message });
        }
    }

    //getAllMethods(_self) {
    //    // First, let's get all property names.
    //    let myPropertyNames = Object.getOwnPropertyNames(_self);
    //    console.log(myPropertyNames);
    //    // And only keep the functions
    //    return myPropertyNames.filter(property => {
    //        // This wil return true for functions, thus
    //        //  telling filter to keep this one.
    //        return typeof (_self[property]) === 'function'
    //    })
    //}
    public isLoaded(): boolean {
        return this._qbr_loaded;
    }

    public callServerMethod(
        _method: string,
        _args: any[],
        _success?: (response: any) => void,
        _failure?: () => void
    ): void {
        try {
            const self = this;
            const method = _method;
            const args = _args;
          
            self._qbr_endpoint.server[_method]
                .apply(self, _args)
                .done((response: any) => {
                    if (typeof _success === 'function') {
                        _success(response);
                    }
                })
                .fail((error: any) => {
                    this.debug('', 'callServerMethod(' + _method + ') - error: ' + error);
                });
        } catch (exception) {
            //JSErrorService.instance(true).LogJSError({ message: exception.message });
            this.debug(self, 'callServerMethod(' + _method + ') - exception: ' + exception.message);
            if (typeof _failure === 'function') {
                _failure();
            }
        }
    }
    private createProxyFunc(method: any) {
        var self = this;
        return function () {
            //this.debug(self, 'ProxyFunc: ' + method);
            this.callServerMethod.apply(self, [method, arguments]);
        }
    }

    private createProxyFunc1(method: string): (...args: any[]) => void {
        const self = this;
        return function (...args: any[]) {
            this.callServerMethod.apply(self, [method, args]);
        };
    }

    private debug(scope: any, message: string): void {
        console.log(scope + ' - ' + message);         
    }
}

export { HubManager };
